( function () {
	'use strict';

	// Temporary fix for ng-touch modal issue on mobile
	// Remove if issue is fix
	// https://github.com/angular-ui/bootstrap/issues/2017

	function stopEvent () {
		return {
			'restrict' : 'A',
			'link'     : function ( scope, element, attr ) {
				element.on( attr.stopEvent, function ( e ) {
					e.stopPropagation();
				} );
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'stopEvent', stopEvent );
} )( );
